import { useMutation } from '@tanstack/react-query';
import { ISaveDraftJobPostPayload } from '../types';
import { PermanentJobsService } from '../services';

export const useSaveDraftJobPost = () => {
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: ISaveDraftJobPostPayload }) =>
      PermanentJobsService.saveDraftJobPost(id, payload),
  });
};
